module.exports = __webpack_public_path__ + "img/c2.84d36bc.png";